import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useIsChromeExtension } from "@src/features/chrome";
import { useThemePreferenceSync } from "@src/features/theme";
import { cn } from "@src/shared/lib/utils";
import { RouterBridge } from "@src/shared/providers/routerBridge";
import { configureCapacitorKeyboard } from "@src/shared/utils/capacitor/configureKeyboard";
import { configureCapacitorStatusBar } from "@src/shared/utils/capacitor/configureStatusBar";

import { useMobileOktaHandoffListener } from "../../../application/v2/useMobileOktaHandoff";

export function RootV2Route() {
  const isChromeExtension = useIsChromeExtension();

  useThemePreferenceSync();
  useMobileOktaHandoffListener();

  useEffect(() => {
    void configureCapacitorStatusBar();
    void configureCapacitorKeyboard();
  }, []);

  return (
    <div
      className={cn(
        "theme-v2 bg-background text-foreground font-sans",
        // The extension panel is a fixed-height overlay, so take its height
        // exactly: that gives descendants a definite height to size and scroll
        // against. Elsewhere the page grows with its content.
        isChromeExtension ? "h-full" : "min-h-full",
      )}
    >
      <RouterBridge />
      <Outlet />
    </div>
  );
}
